import { BaseRouteService } from 'core/services';

class FacilityScheduleRouteService extends BaseRouteService {
    constructor() {
        super('facility-schedules');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,facilityId}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    batchUpdate(resource) {
        return super.batchUpdate(this.base + '/batch', resource);
    }
}

export default FacilityScheduleRouteService;
